import { Grid, Paper, TextField } from '@material-ui/core';
import { productsOutputManagementStore } from 'stores/productsOutputManagement.store';
import shallow from 'zustand/shallow';

export default function ImProductOutputManagementHeader(): JSX.Element {
  const [headerData, setHeaderData, isLoadingSave] = productsOutputManagementStore(
    (state) => [state.headerData, state.setHeaderData, state.isLoadingSave],
    shallow
  );

  return (
    <Paper style={{ padding: '20px 0' }}>
      <Grid container justify="space-evenly">
        <Grid item xs={12} md={5}>
          <TextField
            required
            variant="outlined"
            margin="dense"
            fullWidth
            name="purchaseOrder"
            label="Número de Pedido"
            value={headerData.purchaseOrder}
            onChange={(e) => setHeaderData({ ...headerData, purchaseOrder: e.target.value })}
            autoComplete="off"
            disabled={isLoadingSave}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            variant="outlined"
            margin="dense"
            fullWidth
            name="observations"
            label="Motivo"
            multiline
            rows={3}
            value={headerData.observations}
            onChange={(e) => setHeaderData({ ...headerData, observations: e.target.value })}
            autoComplete="off"
            disabled={isLoadingSave}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
